// The project type (app_project.config.type, chosen in the application's
// project settings; project_type on /me): Sub-metering, Municipality or
// Other. In Sub-metering a group is an apartment and a category its building,
// so the strings naming them have a `_housing` variant — an i18next context,
// passed as t(key, { context }) — the wording the application's Lookup uses
// for housing projects. Municipality and Other keep "group" and "category".
// Free of imports so `node --test` runs it (tests/projectType.test.ts).
export type ProjectType = 'Sub-metering' | 'Municipality' | 'Other';

export type Wording = 'housing' | undefined;

export function wordingFor(projectType: string | null | undefined): Wording {
  return projectType === 'Sub-metering' ? 'housing' : undefined;
}
